// extracted by mini-css-extract-plugin
export default {"publicIcon":"PostMention-module__publicIcon--FA2fC"};